








































import { Vue, Component } from "vue-property-decorator";
import * as AuthStore from "../store/modules/auth";
import Snack from "../utils/snack";

@Component({})
export default class Login extends Vue {
  // Data
  email = "";
  password = "";

  // Computed
  get isLoggingIn() {
    return AuthStore.getters.isLoggingIn;
  }

  // Methods
  async login() {
    if (!this.email || !this.password) {
      return;
    }

    try {
      await AuthStore.actions.login({
        email: this.email,
        password: this.password
      });
    } catch (err) {
      Snack.error(
        "Error logging in. Please check you credentials and try again."
      );
      console.error(err);
    }
  }
}
